import { Component, HostListener, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CountryService } from './services/country.service';
import { PositizeService } from './services/positize.service';
import { VersionCheckService } from './services/version-check.service';
import { Optimus } from '@openng/optimus-ui/config';
import { OPTIMUS_FR } from './optimus-locale';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, TranslateModule],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.component.css',
})
export class AppComponent implements OnInit {
  title = 'Positize_ui';

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.checkMobile();
  }

  checkMobile() {
    const width = window.innerWidth;
    let isMobile = width < 1024;
    console.log('checkMobile', isMobile);
    this.positizeService.setIsMobile(isMobile);
  }

  constructor(
    private translate: TranslateService,
    private versionCheck: VersionCheckService,
    private positizeService: PositizeService,
    private countryService: CountryService,
    private optimus: Optimus
  ) {
    this.checkMobile();
    this.positizeService.language = this.translate.getBrowserLang() ?? 'en';
    console.log('browserLang=' + this.positizeService.language);
    translate.use(
      this.positizeService.language.match(/en|fr/)
        ? this.positizeService.language
        : 'en'
    );
    if (this.positizeService.language === 'fr') {
      this.optimus.setTranslation(OPTIMUS_FR);
    }
    // page language: accessibility, and the French labels of the rich text editors (styles.css)
    document.documentElement.lang = this.positizeService.language === 'fr' ? 'fr' : 'en';
  }

  async ngOnInit() {
    await this.versionCheck.initialize();
    await this.countryService.loadLocale();
    await this.countryService.loadNationalities();
  }
}
